export const categoryDetailsController = {
  initial: 'off',
  states: {
    off: {
      on: {
        LAYOUT_CHANGE_END: {
          target: 'on',
          cond: 'isCategoryDetailsPage',
          actions: ['setBodyNonScrollable'],
        },
      },
    },
    on: {
      initial: 'layoutReloader',
      states: {
        layoutReloader: {
          initial: 'reloading',
          states: {
            idle: {
              on: {
                RELOAD_CATEGORIES: 'reloading',
              },
            },
            reloading: {
              invoke: {
                src: 'getCategoryDetailsLayoutContent',
                onDone: {
                  target: 'idle',
                  actions: [
                    {
                      type: 'batchLayoutOperations',
                      data: '$event.data.updates',
                      meta: {
                        selectors: ['$action.data'],
                      },
                    },
                  ],
                },
              },
            },
          },
        },
      },
      on: {
        ROUTE_CHANGED: [
          {
            target: 'off',
            actions: [
              {
                type: 'setLayoutProperty',
                data: {
                  path: 'components.CategoryDetails.properties.games',
                  value: [],
                },
              },
            ],
          },
        ]
      },
    },
  },
};
